import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['selectButton', 'beforeImage', 'afterImage']

  select(event) {
    const beforeImageId = event.currentTarget.dataset.beforeImageId
    const afterImageId = event.currentTarget.dataset.afterImageId

    this.beforeImageTargets.forEach((el) => {
      if (beforeImageId && el.dataset.beforeImageId === beforeImageId) {
        el.classList.add('is-active')
      } else {
        el.classList.remove('is-active')
      }
    })

    this.afterImageTargets.forEach((el) => {
      if (el.dataset.afterImageId === afterImageId) {
        el.classList.add('is-active')
      } else {
        el.classList.remove('is-active')
      }
    })

    this.selectButtonTargets.forEach((el) => {
      if (el.dataset.afterImageId === afterImageId) {
        el.classList.add('is-active')
      } else {
        el.classList.remove('is-active')
      }
    })
  }
}
